'use client'

import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import { TimeRecordingDrawerEntry } from '../TimeRecordingDrawerEntry/TimeRecordingDrawerEntry'
import { TimeRecordingDateSeparator } from '../TimeRecordingDateSeparator/TimeRecordingDateSeparator'
import { TimeRecordingDailySummary } from '../TimeRecordingDailySummary/TimeRecordingDailySummary'

export const TimeRecordingList = ({ listData = {}, handleSelectTimer, mode }) => {
  const [orderedDates, setOrderedDates] = useState([])

  useEffect(() => {
    // put listDate keys in date order
    const keys = Object.keys(listData)
    const orderedDates = keys?.length ? keys.sort((a, b) => (a < b ? 1 : -1)) : []
    setOrderedDates([...orderedDates])
  }, [listData])

  if (!orderedDates.length) {
    return <div data-testid="TimeRecordingList" />
  }

  return orderedDates.map((groupedDate, index) => (
    <MUIStack key={`${groupedDate}-${index}`} gap={'10px'}>
      <TimeRecordingDateSeparator title={groupedDate} sx={{ position: 'sticky', top: '24px', zIndex: 5 }} />
      {mode === 'postings' && <TimeRecordingDailySummary entries={listData[groupedDate]} groupedDate={groupedDate} />}
      {listData[groupedDate]?.map((entry, i) => (
        <TimeRecordingDrawerEntry
          entry={entry}
          key={`${entry.matterTimerId || entry.timeLedgerPostingId}-${i}`}
          onClick={handleSelectTimer}
        />
      ))}
    </MUIStack>
  ))
}

TimeRecordingList.propTypes = {
  listData: PropTypes.object,
  handleSelectTimer: PropTypes.func,
  mode: PropTypes.string
}
